import axios from 'axios';
import { API_ROOT } from '../constants/constants';
import { getAccessToken } from '../utils/okta-config';

export const getDataWAuth = (url) => {
    return callApi(url, 'get');
}

export const postDataWAuth = (url, data) => {
    return callApi(url, 'post', data);
}

export const getData = (url) => fetch(url).then(resp => resp.json()).catch(e => console.log(e))

export const callApi = (url, method, data) => {
    const accessToken = getAccessToken();

    const headers = {
        'Access-Control-Allow-Origin': API_ROOT,
        Authorization: `Bearer ${accessToken}`
    }

    return axios({ method, url, data, headers })
        .then((response) => {
            if(response.status === 200)
                return response;
            else{
                console.log("Error Loading data !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
                return null;
            }
        })
        .catch((error) => {
            console.log(error);
            return error;
        })
}

